module.exports = "../images/lake.png?v=bf005f3";